import Anime from './anime';
import Challenge from './challenge';

class Selection {
	challenge?: Challenge;
	anime?: Anime;
	completed: boolean = false;
}

export default Selection;



// WEBPACK FOOTER //
// ./src/models/selection.ts